import {GenericService} from '@/shared/xhttp';
import {Address} from '@/models';

export class AddressService extends GenericService<Address> {
}